import { render } from "./CoiImport.vue?vue&type=template&id=4dd02dee&scoped=true"
import script from "./CoiImport.vue?vue&type=script&lang=js"
export * from "./CoiImport.vue?vue&type=script&lang=js"

import "./CoiImport.vue?vue&type=style&index=0&id=4dd02dee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd02dee"]])

export default __exports__